/* Ядро полки: отбор и счёт. Ни одного обращения к сети — ни к нашему серверу,
 * ни к чужому. Всё считается по указателю, который уже лежит в памяти.
 *
 * Главное правило счёта (ради него всё и затевалось):
 *   число рядом со значением характеристики = сколько товаров останется,
 *   если к ТЕКУЩЕМУ набору условий добавить это значение.
 * Заранее сохранённые одиночные числа этого не дают: при сочетании условий
 * они меняются. Поэтому счёт идёт по живому набору, одним проходом.
 *
 * Приём: у каждого товара считаем, скольким АКТИВНЫМ условиям он не отвечает.
 *   0 условий не отвечает           → товар в выдаче и в счёте всех характеристик;
 *   1 условие  не отвечает (пусть f) → товар в счёте ТОЛЬКО характеристики f.
 * Отсюда один проход по товарам вместо прохода на каждую характеристику.
 */
(function (root) {
  'use strict';

  var B36 = '0123456789abcdefghijklmnopqrstuvwxyz';

  function handleize(t) {
    return t.toLowerCase().normalize('NFKD')
            .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function Shelf(doc) {
    this.d = doc;
    this.n = doc.n;
    // строки кодов разворачиваем один раз: charCodeAt в цикле дороже массива
    this.codes = doc.f.map(function (f) {
      var s = f.c, a = new Uint8Array(s.length);
      for (var i = 0; i < s.length; i++) a[i] = s.charCodeAt(i) - 48;
      return a;
    });
    this.avail = new Uint8Array(this.n);
    for (var i = 0; i < this.n; i++) this.avail[i] = doc.a.charCodeAt(i) - 48;
    this.priceMin = Infinity; this.priceMax = 0;
    for (i = 0; i < this.n; i++) {
      var p = doc.p[i];
      if (p < this.priceMin) this.priceMin = p;
      if (p > this.priceMax) this.priceMax = p;
    }
    this.lowTitles = null;     // ленивое: только если понадобится поиск
  }

  Shelf.prototype.handleAt = function (i) {
    return this.d.h[i] || handleize(this.d.t[i]);
  };

  /* Заглушки магазина — не фото. «GENUINE SPARE PARTS» (файл Dolmar-BOWDEN-CABLE-CPL, 255 товаров
     ACC) рисовалась для запчастей и на ноутбуке выглядит дико; серая «Image coming soon»
     (placeholder_noimage, 151). Владелец 14.10.2026: «для ACC товаров надо ЗАМЕНИТЬ картинку
     заглушки». В отделе вместо них — нейтральный блок (zz-shelf-ui.js), в «Рекомендуем» — ниже. */
  // zz-zaglushka-elektronika — новая заглушка товаров ACC без фото (вариант A, слово владельца 15.10.2026)
  var ZAGLUSHKA = /Dolmar-BOWDEN-CABLE-CPL|placeholder_noimage|zz-zaglushka-elektronika/;
  Shelf.prototype.bezFoto = function (i) {
    var s = this.d.img[i];
    if (!s) return true;
    if (s.charAt(0) === '!') return ZAGLUSHKA.test(s);
    return ZAGLUSHKA.test(this.d.ib[B36.indexOf(s.charAt(0))] || '');
  };

  Shelf.prototype.imageAt = function (i, w) {
    var s = this.d.img[i];
    if (!s) return '';
    if (s.charAt(0) === '!') return s.slice(1);
    var b = this.d.ib[B36.indexOf(s.charAt(0))];
    var e = this.d.ie[B36.indexOf(s.charAt(s.length - 1))];
    var tok = s.slice(1, -1);
    var hex = '';
    var bin = atob(tok.replace(/-/g, '+').replace(/_/g, '/') + '==');
    for (var k = 0; k < bin.length; k++) {
      var h = bin.charCodeAt(k).toString(16); hex += h.length < 2 ? '0' + h : h;
    }
    var uuid = hex.slice(0, 8) + '-' + hex.slice(8, 12) + '-' + hex.slice(12, 16) +
               '-' + hex.slice(16, 20) + '-' + hex.slice(20);
    return this.d.cdn + b + '_' + uuid + '_' + (w || 400) + 'x.' + e;
  };

  /* Состояние отбора.
   * facets: { индекс характеристики: [коды значений] }  — внутри характеристики ИЛИ
   * brands: [индексы]    subs: [индексы]                — тоже ИЛИ
   * pmin/pmax в центах, inStock — только в наличии, q — строка поиска.
   * Между собой все условия — И.
   */
  Shelf.prototype.run = function (st) {
    var d = this.d, n = this.n, i, c, k;
    var cons = [];   // список активных условий; id нужен, чтобы знать, кто не пустил

    var fk = Object.keys(st.facets || {});
    for (k = 0; k < fk.length; k++) {
      var fi = +fk[k], want = st.facets[fk[k]];
      if (!want || !want.length) continue;
      var allow = new Uint8Array(41);
      for (i = 0; i < want.length; i++) allow[want[i]] = 1;
      cons.push({ id: 'f' + fi, codes: this.codes[fi], allow: allow, kind: 'f', fi: fi });
    }
    if (st.brands && st.brands.length) {
      var ab = {};
      for (i = 0; i < st.brands.length; i++) ab[st.brands[i]] = 1;
      cons.push({ id: 'brand', kind: 'brand', ab: ab });
    }
    if (st.subs && st.subs.length) {
      var as = {};
      for (i = 0; i < st.subs.length; i++) as[st.subs[i]] = 1;
      cons.push({ id: 'sub', kind: 'sub', as: as });
    }
    // ветка дерева ACC (номер узла в d.kt): товар проходит, если узел есть в его списке d.k
    // (там ветки ВМЕСТЕ с предками — выбор «Phones» берёт и «Phones › Smartphones»)
    if (st.kat != null && st.kat >= 0 && d.k) cons.push({ id: 'kat', kind: 'kat', v: st.kat });
    // сценарий жизни (15.10.2026): подборка из нескольких веток — товар проходит, если есть в любой
    if (st.kats && st.kats.length && d.k) {
      var ks = {};
      for (i = 0; i < st.kats.length; i++) ks[st.kats[i]] = 1;
      cons.push({ id: 'kats', kind: 'kats', ks: ks });
    }
    if (st.pmin != null || st.pmax != null) {
      cons.push({ id: 'price', kind: 'price',
                  lo: st.pmin == null ? -Infinity : st.pmin,
                  hi: st.pmax == null ? Infinity : st.pmax });
    }
    if (st.inStock) cons.push({ id: 'stock', kind: 'stock' });
    // Условие, которое задаёт вызывающий: скидка диапазоном либо одной кнопкой.
    // Идёт тем же путём, что и прочие, — иначе числа у характеристик перестали
    // бы его учитывать, и «скидка + бренд» показало бы не то.
    if (st.extra && typeof st.extra.test === 'function') {
      cons.push({ id: 'extra', kind: 'extra', fn: st.extra.test });
    }
    var q = (st.q || '').trim().toLowerCase();
    if (q) {
      if (!this.lowTitles) {
        this.lowTitles = new Array(n);
        for (i = 0; i < n; i++) this.lowTitles[i] = d.t[i].toLowerCase();
      }
      cons.push({ id: 'q', kind: 'q', words: q.split(/\s+/) });
    }

    var m = cons.length;
    var hits = [];

    // Считать числа у ВСЕХ 555 характеристик на каждом нажатии незачем: человек
    // видит от восьми до дюжины. Замер 12.09.2026: полный пересчёт 18,9 мс
    // против 1,5 мс по видимым — на сервере. На телефоне эта разница и решает,
    // отзывчиво или вязко. Кого считать, говорит вызывающий; по умолчанию всех,
    // иначе проверка сверяла бы не то, что показывает страница.
    var schitat = st.facetsToCount;
    var nado = null;
    if (schitat && schitat.length !== undefined) {
      nado = new Uint8Array(d.f.length);
      for (k = 0; k < schitat.length; k++) nado[schitat[k]] = 1;
      // характеристики с выбранными значениями считаем всегда: иначе человек не
      // увидит, что он выбрал
      for (k = 0; k < fk.length; k++) {
        if (st.facets[fk[k]] && st.facets[fk[k]].length) nado[+fk[k]] = 1;
      }
    }

    // счётчики: по одному массиву на характеристику + бренды + подполки
    var fcount = d.f.map(function (f, i) {
      return (nado && !nado[i]) ? null : new Int32Array(f.v.length + 1);
    });
    // проход делаем ПО СПИСКУ нужных, а не по всем 555 с проверкой на null:
    // сама проверка на 3 898 товарах стоила больше, чем счёт
    var spisok = [];
    for (k = 0; k < d.f.length; k++) if (fcount[k] !== null) spisok.push(k);
    var slen = spisok.length;
    var bcount = new Int32Array(d.brands.length);
    var scount = new Int32Array((d.subs || []).length);
    var kcount = new Int32Array(d.kt ? d.kt.length : 0);
    var stockCount = 0, pmn = Infinity, pmx = 0;

    for (i = 0; i < n; i++) {
      var fails = 0, only = null;
      for (c = 0; c < m; c++) {
        if (!test(cons[c], i, this, d)) {
          fails++;
          if (fails > 1) break;
          only = cons[c];
        }
      }
      if (fails > 1) continue;
      if (fails === 0) {
        hits.push(i);
        if (this.avail[i]) stockCount++;
        var pp = d.p[i];
        if (pp < pmn) pmn = pp;
        if (pp > pmx) pmx = pp;
      }
      // товар идёт в счёт характеристики f, если он не отвечает ТОЛЬКО ей
      if (fails === 0) {
        for (k = 0; k < slen; k++) {
          var fk2 = spisok[k];
          fcount[fk2][this.codes[fk2][i]]++;
        }
      } else if (only.kind === 'f' && fcount[only.fi] !== null) {
        fcount[only.fi][this.codes[only.fi][i]]++;
      }
      if (fails === 0 || only.kind === 'brand') {
        var bi = d.b[i]; if (bi >= 0) bcount[bi]++;
      }
      if (fails === 0 || only.kind === 'sub') {
        var si = d.s ? d.s[i] : -1; if (si >= 0) scount[si]++;
      }
      if (d.k && (fails === 0 || only.kind === 'kat')) {
        var L = d.k[i];
        for (var j = 0; j < L.length; j++) kcount[L[j]]++;
      }
    }

    return {
      hits: hits, total: hits.length,
      facetCounts: fcount, brandCounts: bcount, subCounts: scount, katCounts: kcount,
      inStockCount: stockCount,
      priceMin: pmn === Infinity ? 0 : pmn, priceMax: pmx
    };
  };

  function test(c, i, self, d) {
    switch (c.kind) {
      case 'f':     return c.allow[c.codes[i]] === 1;
      case 'brand': return c.ab[d.b[i]] === 1;
      case 'sub':   return c.as[d.s ? d.s[i] : -1] === 1;
      case 'kat':   return d.k[i].indexOf(c.v) >= 0;
      case 'kats': {
        var L = d.k[i];
        for (var j = 0; j < L.length; j++) if (c.ks[L[j]]) return true;
        return false;
      }
      case 'price': return d.p[i] >= c.lo && d.p[i] <= c.hi;
      case 'stock': return self.avail[i] === 1;
      case 'extra': return !!c.fn(i);
      case 'q': {
        var t = self.lowTitles[i];
        for (var w = 0; w < c.words.length; w++) if (t.indexOf(c.words[w]) < 0) return false;
        return true;
      }
    }
    return true;
  }

  Shelf.prototype.sort = function (hits, mode) {
    var d = this.d, self = this;
    var a = hits.slice();
    if (mode === 'priceasc')  a.sort(function (x, y) { return d.p[x] - d.p[y]; });
    else if (mode === 'pricedesc') a.sort(function (x, y) { return d.p[y] - d.p[x]; });
    else if (mode === 'name') a.sort(function (x, y) { return d.t[x] < d.t[y] ? -1 : d.t[x] > d.t[y] ? 1 : 0; });
    else if (mode === 'stock') a.sort(function (x, y) { return self.avail[y] - self.avail[x]; });
    // «Рекомендуем» (владелец 14.10.2026: «я выбрал телефоны, а вылезли аксессуары… другие
    // гаджеты»). Порядок, не отбор: счёт и фильтры не меняются.
    //   1) ступень раздела: основное полки → без раздела → второстепенное (чехлы, умный дом,
    //      серверы, крепления, инфопанели, расходники…). Сортировка по цене поднимала наверх
    //      серверы за 7 000 € и инфопанели за 19 000 € — от неё отказались;
    //   2) в наличии раньше; 3) спрос у ACC (d.u) больше раньше; 4) дороже раньше.
    else if (mode === 'glavnoe') {
      var VTOR = /^(cases|smart-home|pc-accessories|servers|accessories|mounts|signage|projectors|consumables|power|ups|av|cookware|racks|kvm|docks)$/;
      var stup = new Uint8Array(d.subs ? d.subs.length : 0);
      (d.subs || []).forEach(function (h, i) { stup[i] = VTOR.test(h) ? 2 : 0; });
      // 15.10.2026: товар в ветке дерева ACC «Accessories» (чехлы, зарядки, крепления…) — тоже
      // второстепенное: «телефоны — это не чехлы» (владелец). Имя en узла — kt[u][3] после перевода.
      var aks = new Uint8Array(self.n);
      if (d.kt && d.k) {
        var uzAks = d.kt.map(function (u) { return (u[3] || u[1]) === 'Accessories' ? 1 : 0; });
        for (var m = 0; m < self.n; m++) {
          var L = d.k[m];
          for (var j = 0; j < L.length; j++) if (uzAks[L[j]]) { aks[m] = 1; break; }
        }
      }
      var st = function (i) { var si = d.s ? d.s[i] : -1; return Math.max(si >= 0 ? stup[si] : 1, aks[i] ? 2 : 0); };
      var u = d.u || [];
      var bf = new Uint8Array(self.n);
      for (var k = 0; k < self.n; k++) bf[k] = self.bezFoto(k) ? 1 : 0;      // без фото — ниже
      a.sort(function (x, y) {
        return st(x) - st(y) || bf[x] - bf[y] || self.avail[y] - self.avail[x] || (u[y] || 0) - (u[x] || 0) || d.p[y] - d.p[x];
      });
    }
    return a;
  };

  root.ZZShelf = { Shelf: Shelf, handleize: handleize };
})(typeof window !== 'undefined' ? window : globalThis);

if (typeof module !== 'undefined' && module.exports) {
  module.exports = (typeof window !== 'undefined' ? window : globalThis).ZZShelf;
}
